import React from 'react'
import './App.css'; 
import Header from './Components/Header'
import List from './Components/List';
function App() {
  return (
    <div>
      <Header />
      <div className='Container'>

        <div className="list">
          <List  />
        </div>
       <span className="lastPart">
        Thanks for Visiting!!!!
       </span>
      </div>
    </div>
  );
}

export default App;
